var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      this.$route.name !== "employees.create"
        ? _c(
            "tooltip-btn",
            {
              attrs: { rounded: "", tooltip: "New Employee" },
              on: {
                click: function($event) {
                  return _vm.$router.push("/employees/create")
                }
              }
            },
            [
              _c("v-icon", [_vm._v("mdi-account")]),
              _c("v-icon", [_vm._v("mdi-plus")])
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "mt-2" },
        [_c("router-view", { on: { "open-dialog": _vm.openDialog } })],
        1
      ),
      _c("e-dialog", {
        model: {
          value: _vm.dialog,
          callback: function($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }